import React from 'react';
import { Box, Container, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PublicFooter = () => (
  <Box component="footer" sx={{ bgcolor: 'grey.900', color: 'grey.300', py: 4 }}>
    <Container maxWidth="lg">
      <Typography variant="body2" sx={{ mb: 1.5, lineHeight: 1.7 }}>
        Deer detection ships as a small fine-tuned YOLO model and does not need a GPU.
        If you are not running a large vision model, that YOLO model fits a smaller computer, including a Raspberry Pi.
        A GPU is only for checking that model with a large vision model, or for fine-tuning
        your own small model so you can later move it back to the smaller computer.
        The factory USB image is larger: 16 GB of RAM and 80 GB of disk, because it includes the desktop and hub.
        Wildfire detection is in development.
      </Typography>
      <Typography variant="body2" sx={{ mb: 1.5, lineHeight: 1.7 }}>
        Software is $15 per gateway per month after a 30-day trial.
        Checkout collects a card and does not charge it during the trial.
        Cancel before the trial ends, or the plan continues at $15 per month per gateway.
        Large-vision checks are not a separate priced add-on. They use a GPU you supply.
        Setup is do-it-yourself.
      </Typography>
      <Typography variant="body2">
        <Link component={RouterLink} to="/install-gateway" color="inherit" underline="always">
          Install guide
        </Link>
        {' · '}
        <Link component={RouterLink} to="/subscription/plans" color="inherit" underline="always">
          Pricing
        </Link>
        {' · '}
        <Link href="mailto:info@pomsoft.net" color="inherit" underline="always">
          info@pomsoft.net
        </Link>
      </Typography>
      <Typography variant="caption" display="block" sx={{ mt: 2 }}>
        © 2026 EyeSense.ai. All rights reserved.
      </Typography>
    </Container>
  </Box>
);

export default PublicFooter;
